import { createBottomSheetV2 } from '@shared/components/BottomSheetV2';
import { HandleSendEmailArgs } from '@shared/components/EmailsAndEcards/components/Confirm/Confirm.controller';

/**
 * Context for the PostOffice bottom sheet.
 *
 * Required properties are set at initialization and available throughout the entire flow.
 * Optional properties are set by specific controllers/views as needed during the flow.
 */
type PostOfficeBottomSheetContext = Readonly<{
  eventHandle: string;
  isConfirmSheetOpen: boolean;
  handleSendEmail?: (args: HandleSendEmailArgs) => void;
  email?: string;
  recipientName?: string;
  redirect?: string;
  handleSendTestEmailDialogClose?: () => void;
  handleSendTestEmailDialogOpen?: () => void;
  openEmailEditor?: () => void;
  openECardEditor?: () => void;
  disableEditEmail?: boolean;
  handleCopyShareableLink?: (generatedLink: string) => void;
  isCreatingShareableLink?: boolean;
  generateShareableLink?: () => Promise<string | null>;
}>;

export const [PostOfficeBottomSheetProvider, usePostOfficeBottomSheetState, PostOfficeBottomSheet] = createBottomSheetV2<PostOfficeBottomSheetContext>({
  name: 'PostOfficeBottomSheet',
});
